import React from 'react'
import PropTypes from 'prop-types'
import { Copy, Flex, themeColor } from '@elparking/components'

import { FormattedMessage } from 'react-intl'
import PriceContainer from '../PriceContainer'
import styled from 'styled-components'

const VehicleInspectionLowerPriceContainer = styled(Flex)`
    background-color: ${themeColor('main20')};
`

function VehicleInspectionProductSelectorHeader ({product}) {
    return (
        <>
            <VehicleInspectionLowerPriceContainer alignItems='center' mx={['12px', '0']} pt={['8px', '24px']} pb={['8px', '12px']} px={['16px', '12px']}>
                <Copy color='gray' fontSize='medium' padding='0 8px 0 0'>
                    <FormattedMessage defaultMessage='Pasa la ITV desde' />
                </Copy>
                <PriceContainer
                  color='gray'
                  originalPrice={product.originalPrice}
                  totalPrice={product.totalPrice}
                />
            </VehicleInspectionLowerPriceContainer>
        </>
    )
}

VehicleInspectionProductSelectorHeader.propTypes = {
    product: PropTypes.object,
}

export default VehicleInspectionProductSelectorHeader
